'use client';

import { useState } from 'react';
import RegistrationForm from './RegistrationForm';

const stepLabels = ['Maklumat Peribadi', 'Pengesahan IC & Dokumen', 'Pembayaran & Terma'];
const totalSteps = 3;

export default function RegistrationFormCard() {
  const [currentStep, setCurrentStep] = useState(1);
  const progress = Math.round((currentStep / totalSteps) * 100);

  return (
    <div className="bg-card rounded-3xl shadow-2xl overflow-hidden border border-brandDark/10">
      <div className="bg-brandDark p-8 text-center text-white">
        <h2 className="text-2xl font-heading font-black mb-2">Borang Pendaftaran Ejen</h2>
        <p className="text-white/70 text-sm">
          Lengkapkan maklumat anda untuk memulakan kerjaya baru
        </p>
      </div>
      <div className="w-full bg-brandDark/20 h-3">
        <div
          className="h-full transition-all duration-700 shadow-sm bg-gradient-to-r from-[#bf953f] via-[#fcf6ba] to-[#aa771c]"
          style={{ width: `${progress}%` }}
        ></div>
      </div>
      <div className="p-8 md:p-12">
        <div className="flex items-center justify-between mb-10">
          <div className="flex flex-col">
            <span className="text-xs font-cta font-black text-accent uppercase tracking-widest">
              Langkah {currentStep}
            </span>
            <h3 className="text-xl font-heading font-bold text-textPrimary">
              {stepLabels[currentStep - 1]}
            </h3>
          </div>
          <div className="text-right">
            <span className="text-xs font-body font-bold text-textSecondary">
              STATUS: {progress}% SIAP
            </span>
          </div>
        </div>
        <RegistrationForm onStepChange={setCurrentStep} />
      </div>
    </div>
  );
}
